module.exports = __webpack_public_path__ + "img/1.7c7228a3.png";